"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsContent = void 0;
const languageUtils_1 = require("../languageUtils");
// NOTE: Record<keys, values>
const productsText = {
    en: {
        preorder: 'Available Now',
        country: 'country',
        edition: 'edition',
        platform: 'platform',
        retailers: 'retailers',
        preorderBtn: 'Available Now!',
        selectAnOption: 'Select An Option',
        comingSoon: 'Coming Soon',
        demoTitle: 'Demo Available Now',
        disclaimer: 'PlayStation®5 and Xbox Series X|S users who purchase the Digital Deluxe or Super Digital Deluxe Edition must manually download the Expansion Pack, Reclaimers Outfit Set, and Sovereign Axiom Outfit Set when they become available.',
        keyTitle: 'Key Features',
        play: 'Play through the early part of the story',
        save: 'Save data carries over to the full game',
        playSolo: 'Play solo or with friends in online co-op with crossplay',
        specTitle: 'System Requirements',
        minText: 'Minimum:',
        requireText: 'Requires a 64-bit processor and operating system',
        osText: '<span class="paragraph paragraph--sm__font paragraph--neun">OS:</span> Windows 10',
        processorText: '<span class="paragraph paragraph--sm__font paragraph--neun">Processor:</span> Intel Core i5-10400',
        memoryText: '<span class="paragraph paragraph--sm__font paragraph--neun">Memory:</span> 16 GB RAM',
        graphicsText: '<span class="paragraph paragraph--sm__font paragraph--neun">Graphics:</span> NVIDIA GeForce GTX 1050',
        directxText: '<span class="paragraph paragraph--sm__font paragraph--neun">DirectX:</span> Version 12',
        storageText: '<span class="paragraph paragraph--sm__font paragraph--neun">Storage:</span> 50 GB available space',
        additionalText: '<span class="paragraph paragraph--sm__font paragraph--neun">Additional Notes:</span> SSD recommended',
        recommendedText: 'recommended:',
        processor2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Processor:</span> Intel Core i7-12700',
        memory2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Memory:</span> 32 GB RAM',
        graphics2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Graphics:</span> NVIDIA GeForce RTX 3070',
        dlcTitle: 'DLC Items',
        dlcAbout: "The following DLC can be obtained on each platform's digital storefront.",
        dlcArsenal: 'Arsenal Skin Set',
        dlcEquipment: 'Special Equipment Set',
        dlcSFX: 'Special SFX Weapon Set',
        dlchairstyles: 'Free Hairstyles',
        dlcemotes: 'Free Emotes',
        dlcAvatar1: 'Avatar Customization Pack 1',
        dlcAvatar2: 'Avatar Customization Pack 2',
        dlcEmote2: 'Emote Set',
        dlcFreeReclaimer: 'Reclaimers Outfit Set',
        dlcHairstyle: 'Hairstyle Set 1',
        dlcHairstyle2: 'Hairstyle Set 2',
        dlcHairstyle3: 'Hairstyle Set 3',
        dlcHairstyle4: 'Hairstyle Set 4',
        dlcHairstyle5: 'Hairstyle Set 5',
        dlcHairstyle6: 'Hairstyle Set 6',
        dlcHairstyle7: 'Hairstyle Set 7',
        dlcHairstyle8: 'Hairstyle Set 8',
        firstReleaseText: '9.24 Release',
        gamelaunchText: 'Available at Game Launch',
        roadmapText: "The 1st free update's additional boss, “Grausam RT: Ω,” has been released ahead of schedule on 9/24 instead of the originally planned 10/2 date.",
        dlcAvatar3: 'Avatar Customization Pack 3',
        dlcAvatar4: 'Avatar Customization Pack 4',
        dlcIrisOutfit: 'Free Iris Outfit',
        secondReleaseText: '10.2 Release',
        thirdReleaseText: '10.16 Release',
        dlc__formalsuit: 'Free Formal Suit Outfit',
        dlc__axiomresearcher: 'Free Axiom Researcher Outfit',
        dlc__sovereign: 'Sovereign Axiom Outfit Set',
        dlc__grand1: 'Grand Entrance Set 1',
        dlc__grand2: 'Grand Entrance Set 2',
        dlc__vehicle: 'Vehicle Set',
        dlc__decal: 'Decal Set',
        fourthdReleaseText: '10.29 Release',
        dlc__intoabyss: 'Into the Abyss (Expansion Pack)',
        dlc__avatarcustom5: 'Avatar Customization Pack 5',
        dlc__stampset: 'Stamp Set',
        fifthReleaseText: '11.13 Release',
        dlc__valkyrie: 'Metallic Equipment - Valkyrie Will (Lance)',
        dlc__noxus: 'Metallic Equipment - Noxus Glitter (Laser Rifle)',
        dlc__silverraven: 'Metallic Equipment - Silver Raven (Machine Gun)',
        dlc__grimreaper: 'Metallic Equipment - Grim Reaper (Assault Rifle)',
        dlc__levendis: 'Metallic Equipment - Levendis (Blade)',
        dlc__shiden: 'Metallic Equipment - Shiden (Taichi)',
        sixthReleaseText: '12.4 Release',
    },
    ca: {
        preorder: 'Available Now',
        country: 'country',
        edition: 'edition',
        platform: 'platform',
        retailers: 'retailers',
        preorderBtn: 'Available Now!',
        selectAnOption: 'Select An Option',
        comingSoon: 'Coming Soon',
        demoTitle: 'Demo Available Now',
        disclaimer: 'PlayStation®5 and Xbox Series X|S users who purchase the Digital Deluxe or Super Digital Deluxe Edition must manually download the Expansion Pack, Reclaimers Outfit Set, and Sovereign Axiom Outfit Set when they become available.',
        keyTitle: 'Key Features',
        play: 'Play through the early part of the story',
        save: 'Save data carries over to the full game',
        playSolo: 'Play solo or with friends in online co-op with crossplay',
        specTitle: 'System Requirements',
        minText: 'Minimum:',
        requireText: 'Requires a 64-bit processor and operating system',
        osText: '<span class="paragraph paragraph--sm__font paragraph--neun">OS:</span> Windows 10',
        processorText: '<span class="paragraph paragraph--sm__font paragraph--neun">Processor:</span> Intel Core i5-10400',
        memoryText: '<span class="paragraph paragraph--sm__font paragraph--neun">Memory:</span> 16 GB RAM',
        graphicsText: '<span class="paragraph paragraph--sm__font paragraph--neun">Graphics:</span> NVIDIA GeForce GTX 1050',
        directxText: '<span class="paragraph paragraph--sm__font paragraph--neun">DirectX:</span> Version 12',
        storageText: '<span class="paragraph paragraph--sm__font paragraph--neun">Storage:</span> 50 GB available space',
        additionalText: '<span class="paragraph paragraph--sm__font paragraph--neun">Additional Notes:</span> SSD recommended',
        recommendedText: 'recommended:',
        processor2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Processor:</span> Intel Core i7-12700',
        memory2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Memory:</span> 32 GB RAM',
        graphics2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Graphics:</span> NVIDIA GeForce RTX 3070',
        dlcTitle: 'DLC Items',
        dlcAbout: "The following DLC can be obtained on each platform's digital storefront.",
        dlcArsenal: 'Arsenal Skin Set',
        dlcEquipment: 'Special Equipment Set',
        dlcSFX: 'Special SFX Weapon Set',
        dlchairstyles: 'Free Hairstyles',
        dlcemotes: 'Free Emotes',
        dlcAvatar1: 'Avatar Customization Pack 1',
        dlcAvatar2: 'Avatar Customization Pack 2',
        dlcEmote2: 'Emote Set',
        dlcFreeReclaimer: 'Reclaimers Outfit Set',
        dlcHairstyle: 'Hairstyle Set 1',
        dlcHairstyle2: 'Hairstyle Set 2',
        dlcHairstyle3: 'Hairstyle Set 3',
        dlcHairstyle4: 'Hairstyle Set 4',
        dlcHairstyle5: 'Hairstyle Set 5',
        dlcHairstyle6: 'Hairstyle Set 6',
        dlcHairstyle7: 'Hairstyle Set 7',
        dlcHairstyle8: 'Hairstyle Set 8',
        firstReleaseText: '9.24 Release',
        gamelaunchText: 'Available at Game Launch',
        roadmapText: "The 1st free update's additional boss, “Grausam RT: Ω,” has been released ahead of schedule on 9/24 instead of the originally planned 10/2 date.",
        dlcAvatar3: 'Avatar Customization Pack 3',
        dlcAvatar4: 'Avatar Customization Pack 4',
        dlcIrisOutfit: 'Free Iris Outfit',
        secondReleaseText: '10.2 Release',
        thirdReleaseText: '10.16 Release',
        dlc__formalsuit: 'Free Formal Suit Outfit',
        dlc__axiomresearcher: 'Free Axiom Researcher Outfit',
        dlc__sovereign: 'Sovereign Axiom Outfit Set',
        dlc__grand1: 'Grand Entrance Set 1',
        dlc__grand2: 'Grand Entrance Set 2',
        dlc__vehicle: 'Vehicle Set',
        dlc__decal: 'Decal Set',
        fourthdReleaseText: '10.29 Release',
        dlc__intoabyss: 'Into the Abyss (Expansion Pack)',
        dlc__avatarcustom5: 'Avatar Customization Pack 5',
        dlc__stampset: 'Stamp Set',
        fifthReleaseText: '11.13 Release',
        dlc__valkyrie: 'Metallic Equipment - Valkyrie Will (Lance)',
        dlc__noxus: 'Metallic Equipment - Noxus Glitter (Laser Rifle)',
        dlc__silverraven: 'Metallic Equipment - Silver Raven (Machine Gun)',
        dlc__grimreaper: 'Metallic Equipment - Grim Reaper (Assault Rifle)',
        dlc__levendis: 'Metallic Equipment - Levendis (Blade)',
        dlc__shiden: 'Metallic Equipment - Shiden (Taichi)',
        sixthReleaseText: '12.4 Release',
    },
    uk: {
        preorder: 'Available Now',
        country: 'country',
        edition: 'edition',
        platform: 'platform',
        retailers: 'retailers',
        preorderBtn: 'Available Now!',
        selectAnOption: 'Select An Option',
        comingSoon: 'Coming Soon',
        demoTitle: 'Demo Available Now',
        disclaimer: 'PlayStation®5 and Xbox Series X|S users who purchase the Digital Deluxe or Super Digital Deluxe Edition must manually download the Expansion Pack, Reclaimers Outfit Set, and Sovereign Axiom Outfit Set when they become available.',
        keyTitle: 'Key Features',
        play: 'Play through the early part of the story',
        save: 'Save data carries over to the full game',
        playSolo: 'Play solo or with friends in on-line co-op, across any platform',
        specTitle: 'System Requirements',
        minText: 'Minimum:',
        requireText: 'Requires a 64-bit processor and operating system',
        osText: '<span class="paragraph paragraph--sm__font paragraph--neun">OS:</span> Windows 10',
        processorText: '<span class="paragraph paragraph--sm__font paragraph--neun">Processor:</span> Intel Core i5-10400',
        memoryText: '<span class="paragraph paragraph--sm__font paragraph--neun">Memory:</span> 16 GB RAM',
        graphicsText: '<span class="paragraph paragraph--sm__font paragraph--neun">Graphics:</span> NVIDIA GeForce GTX 1050',
        directxText: '<span class="paragraph paragraph--sm__font paragraph--neun">DirectX:</span> Version 12',
        storageText: '<span class="paragraph paragraph--sm__font paragraph--neun">Storage:</span> 50 GB available space',
        additionalText: '<span class="paragraph paragraph--sm__font paragraph--neun">Additional Notes:</span> SSD recommended',
        recommendedText: 'recommended:',
        processor2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Processor:</span> Intel Core i7-12700',
        memory2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Memory:</span> 32 GB RAM',
        graphics2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Graphics:</span> NVIDIA GeForce RTX 3070',
        dlcTitle: 'DLC',
        dlcAbout: '',
        dlcArsenal: 'Arsenal Skin Set',
        dlcEquipment: 'Special Equipment Set',
        dlcSFX: 'Special SFX Weapon Set',
        dlchairstyles: 'Free Hairstyles',
        dlcemotes: 'Free Emotes',
        dlcAvatar1: 'Avatar Customization Pack 1',
        dlcAvatar2: 'Avatar Customization Pack 2',
        dlcEmote2: 'Emote Set',
        dlcFreeReclaimer: 'Reclaimers Outfit Set',
        dlcHairstyle: 'Hairstyle Set 1',
        dlcHairstyle2: 'Hairstyle Set 2',
        dlcHairstyle3: 'Hairstyle Set 3',
        dlcHairstyle4: 'Hairstyle Set 4',
        dlcHairstyle5: 'Hairstyle Set 5',
        dlcHairstyle6: 'Hairstyle Set 6',
        dlcHairstyle7: 'Hairstyle Set 7',
        dlcHairstyle8: 'Hairstyle Set 8',
        firstReleaseText: '25 September',
        gamelaunchText: 'Available at Game Launch',
        roadmapText: "The 1st free update's additional boss, Grausam RT: Ω, has been released ahead of schedule on September 25 instead of the originally planned October 3 date.",
        dlcAvatar3: 'Avatar Customization Pack 3',
        dlcAvatar4: 'Avatar Customization Pack 4',
        dlcIrisOutfit: 'Free Iris Outfit',
        secondReleaseText: '3 October',
        thirdReleaseText: '17 October',
        dlc__formalsuit: 'Free Formal Suit Outfit',
        dlc__axiomresearcher: 'Free Axiom Researcher Outfit',
        dlc__sovereign: 'Sovereign Axiom Outfit Set',
        dlc__grand1: 'Grand Entrance Set 1',
        dlc__grand2: 'Grand Entrance Set 2',
        dlc__vehicle: 'Vehicle Set',
        dlc__decal: 'Decal Set',
        fourthdReleaseText: '30 October',
        dlc__intoabyss: 'Into the Abyss',
        dlc__avatarcustom5: 'Avatar Customization Pack 5',
        dlc__stampset: 'Stamp Set',
        fifthReleaseText: '14 November',
        dlc__valkyrie: 'Metallic Equipment - Valkyrie Will (Lance)',
        dlc__noxus: 'Metallic Equipment - Noxus Glitter (Laser Rifle)',
        dlc__silverraven: 'Metallic Equipment - Silver Raven (Machine Gun)',
        dlc__grimreaper: 'Metallic Equipment - Grim Reaper (Assault Rifle)',
        dlc__levendis: 'Metallic Equipment - Levendis (Blade)',
        dlc__shiden: 'Metallic Equipment - Shiden (Taichi)',
        sixthReleaseText: '5 December',
    },
    au: {
        preorder: 'Available Now',
        country: 'country',
        edition: 'edition',
        platform: 'platform',
        retailers: 'retailers',
        preorderBtn: 'Available Now!',
        selectAnOption: 'Select An Option',
        comingSoon: 'Coming Soon',
        demoTitle: 'Demo Available Now',
        disclaimer: 'PlayStation®5 and Xbox Series X|S users who purchase the Digital Deluxe or Super Digital Deluxe Edition must manually download the Expansion Pack, Reclaimers Outfit Set, and Sovereign Axiom Outfit Set when they become available.',
        keyTitle: 'Key Features',
        play: 'Play through the early part of the story',
        save: 'Save data carries over to the full game',
        playSolo: 'Play solo or with friends in on-line co-op, across any platform',
        specTitle: 'System Requirements',
        minText: 'Minimum:',
        requireText: 'Requires a 64-bit processor and operating system',
        osText: '<span class="paragraph paragraph--sm__font paragraph--neun">OS:</span> Windows 10',
        processorText: '<span class="paragraph paragraph--sm__font paragraph--neun">Processor:</span> Intel Core i5-10400',
        memoryText: '<span class="paragraph paragraph--sm__font paragraph--neun">Memory:</span> 16 GB RAM',
        graphicsText: '<span class="paragraph paragraph--sm__font paragraph--neun">Graphics:</span> NVIDIA GeForce GTX 1050',
        directxText: '<span class="paragraph paragraph--sm__font paragraph--neun">DirectX:</span> Version 12',
        storageText: '<span class="paragraph paragraph--sm__font paragraph--neun">Storage:</span> 50 GB available space',
        additionalText: '<span class="paragraph paragraph--sm__font paragraph--neun">Additional Notes:</span> SSD recommended',
        recommendedText: 'recommended:',
        processor2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Processor:</span> Intel Core i7-12700',
        memory2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Memory:</span> 32 GB RAM',
        graphics2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Graphics:</span> NVIDIA GeForce RTX 3070',
        dlcTitle: 'DLC',
        dlcAbout: '',
        dlcArsenal: 'Arsenal Skin Set',
        dlcEquipment: 'Special Equipment Set',
        dlcSFX: 'Special SFX Weapon Set',
        dlchairstyles: 'Free Hairstyles',
        dlcemotes: 'Free Emotes',
        dlcAvatar1: 'Avatar Customization Pack 1',
        dlcAvatar2: 'Avatar Customization Pack 2',
        dlcEmote2: 'Emote Set',
        dlcFreeReclaimer: 'Reclaimers Outfit Set',
        dlcHairstyle: 'Hairstyle Set 1',
        dlcHairstyle2: 'Hairstyle Set 2',
        dlcHairstyle3: 'Hairstyle Set 3',
        dlcHairstyle4: 'Hairstyle Set 4',
        dlcHairstyle5: 'Hairstyle Set 5',
        dlcHairstyle6: 'Hairstyle Set 6',
        dlcHairstyle7: 'Hairstyle Set 7',
        dlcHairstyle8: 'Hairstyle Set 8',
        firstReleaseText: '25 September',
        gamelaunchText: 'Available at Game Launch',
        roadmapText: "The 1st free update's additional boss, Grausam RT: Ω, has been released ahead of schedule on September 25 instead of the originally planned October 3 date.",
        dlcAvatar3: 'Avatar Customization Pack 3',
        dlcAvatar4: 'Avatar Customization Pack 4',
        dlcIrisOutfit: 'Free Iris Outfit',
        secondReleaseText: '3 October',
        thirdReleaseText: '17 October',
        dlc__formalsuit: 'Free Formal Suit Outfit',
        dlc__axiomresearcher: 'Free Axiom Researcher Outfit',
        dlc__sovereign: 'Sovereign Axiom Outfit Set',
        dlc__grand1: 'Grand Entrance Set 1',
        dlc__grand2: 'Grand Entrance Set 2',
        dlc__vehicle: 'Vehicle Set',
        dlc__decal: 'Decal Set',
        fourthdReleaseText: '30 October',
        dlc__intoabyss: 'Into the Abyss',
        dlc__avatarcustom5: 'Avatar Customization Pack 5',
        dlc__stampset: 'Stamp Set',
        fifthReleaseText: '14 November',
        dlc__valkyrie: 'Metallic Equipment - Valkyrie Will (Lance)',
        dlc__noxus: 'Metallic Equipment - Noxus Glitter (Laser Rifle)',
        dlc__silverraven: 'Metallic Equipment - Silver Raven (Machine Gun)',
        dlc__grimreaper: 'Metallic Equipment - Grim Reaper (Assault Rifle)',
        dlc__levendis: 'Metallic Equipment - Levendis (Blade)',
        dlc__shiden: 'Metallic Equipment - Shiden (Taichi)',
        sixthReleaseText: '5 December',
    },
    nz: {
        preorder: 'Available Now',
        country: 'country',
        edition: 'edition',
        platform: 'platform',
        retailers: 'retailers',
        preorderBtn: 'Available Now!',
        selectAnOption: 'Select An Option',
        comingSoon: 'Coming Soon',
        demoTitle: 'Demo Available Now',
        disclaimer: 'PlayStation®5 and Xbox Series X|S users who purchase the Digital Deluxe or Super Digital Deluxe Edition must manually download the Expansion Pack, Reclaimers Outfit Set, and Sovereign Axiom Outfit Set when they become available.',
        keyTitle: 'Key Features',
        play: 'Play through the early part of the story',
        save: 'Save data carries over to the full game',
        playSolo: 'Play solo or with friends in online co-op with crossplay',
        specTitle: 'System Requirements',
        minText: 'Minimum:',
        requireText: 'Requires a 64-bit processor and operating system',
        osText: '<span class="paragraph paragraph--sm__font paragraph--neun">OS:</span> Windows 10',
        processorText: '<span class="paragraph paragraph--sm__font paragraph--neun">Processor:</span> Intel Core i5-10400',
        memoryText: '<span class="paragraph paragraph--sm__font paragraph--neun">Memory:</span> 16 GB RAM',
        graphicsText: '<span class="paragraph paragraph--sm__font paragraph--neun">Graphics:</span> NVIDIA GeForce GTX 1050',
        directxText: '<span class="paragraph paragraph--sm__font paragraph--neun">DirectX:</span> Version 12',
        storageText: '<span class="paragraph paragraph--sm__font paragraph--neun">Storage:</span> 50 GB available space',
        additionalText: '<span class="paragraph paragraph--sm__font paragraph--neun">Additional Notes:</span> SSD recommended',
        recommendedText: 'recommended:',
        processor2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Processor:</span> Intel Core i7-12700',
        memory2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Memory:</span> 32 GB RAM',
        graphics2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Graphics:</span> NVIDIA GeForce RTX 3070',
        dlcTitle: 'DLC',
        dlcAbout: '',
        dlcArsenal: 'Arsenal Skin Set',
        dlcEquipment: 'Special Equipment Set',
        dlcSFX: 'Special SFX Weapon Set',
        dlchairstyles: 'Free Hairstyles',
        dlcemotes: 'Free Emotes',
        dlcAvatar1: 'Avatar Customization Pack 1',
        dlcAvatar2: 'Avatar Customization Pack 2',
        dlcEmote2: 'Emote Set',
        dlcFreeReclaimer: 'Reclaimers Outfit Set',
        dlcHairstyle: 'Hairstyle Set 1',
        dlcHairstyle2: 'Hairstyle Set 2',
        dlcHairstyle3: 'Hairstyle Set 3',
        dlcHairstyle4: 'Hairstyle Set 4',
        dlcHairstyle5: 'Hairstyle Set 5',
        dlcHairstyle6: 'Hairstyle Set 6',
        dlcHairstyle7: 'Hairstyle Set 7',
        dlcHairstyle8: 'Hairstyle Set 8',
        firstReleaseText: '25 September',
        gamelaunchText: 'Available at Game Launch',
        roadmapText: "The 1st free update's additional boss, Grausam RT: Ω, has been released ahead of schedule on September 25 instead of the originally planned October 3 date.",
        dlcAvatar3: 'Avatar Customization Pack 3',
        dlcAvatar4: 'Avatar Customization Pack 4',
        dlcIrisOutfit: 'Free Iris Outfit',
        secondReleaseText: '3 October',
        thirdReleaseText: '17 October',
        dlc__formalsuit: 'Free Formal Suit Outfit',
        dlc__axiomresearcher: 'Free Axiom Researcher Outfit',
        dlc__sovereign: 'Sovereign Axiom Outfit Set',
        dlc__grand1: 'Grand Entrance Set 1',
        dlc__grand2: 'Grand Entrance Set 2',
        dlc__vehicle: 'Vehicle Set',
        dlc__decal: 'Decal Set',
        fourthdReleaseText: '30 October',
        dlc__intoabyss: 'Into the Abyss',
        dlc__avatarcustom5: 'Avatar Customization Pack 5',
        dlc__stampset: 'Stamp Set',
        fifthReleaseText: '14 November',
        dlc__valkyrie: 'Metallic Equipment - Valkyrie Will (Lance)',
        dlc__noxus: 'Metallic Equipment - Noxus Glitter (Laser Rifle)',
        dlc__silverraven: 'Metallic Equipment - Silver Raven (Machine Gun)',
        dlc__grimreaper: 'Metallic Equipment - Grim Reaper (Assault Rifle)',
        dlc__levendis: 'Metallic Equipment - Levendis (Blade)',
        dlc__shiden: 'Metallic Equipment - Shiden (Taichi)',
        sixthReleaseText: '5 December',
    },
    fr: {
        preorder: 'Maintenant disponible',
        country: 'Pays',
        edition: 'Édition',
        platform: 'Plateforme',
        retailers: 'Boutiques',
        preorderBtn: 'Maintenant disponible !',
        selectAnOption: 'Sélectionner une option',
        comingSoon: 'Bientôt disponible',
        demoTitle: 'Démo disponible',
        disclaimer: "Les utilisateurs de PlayStation®5 et Xbox Series X|S qui achètent l'édition Digital Deluxe ou Super Digital Deluxe doivent télécharger manuellement le pack d'extension, l'ensemble de tenues Reclaimers et l'ensemble de tenues Sovereign Axiom lorsqu'ils seront disponibles.",
        keyTitle: 'Caractéristiques principales',
        play: "Jouez la première partie de l'histoire",
        save: 'Les données sauvegardées sont transférées vers le jeu complet',
        playSolo: 'Jouez en solo ou avec des amis en mode coopératif en ligne avec le crossplay ',
        specTitle: 'Configuration requise',
        minText: 'Minimale :',
        requireText: "Système d'exploitation et processeur 64 bits nécess",
        osText: '<span class="paragraph paragraph--sm__font paragraph--neun">Système d\'exploitation :</span> Windows 10',
        processorText: '<span class="paragraph paragraph--sm__font paragraph--neun">Processeur :</span> Intel Core i5-10400',
        memoryText: '<span class="paragraph paragraph--sm__font paragraph--neun">Mémoire vive :</span> 16 GB de mémoire',
        graphicsText: '<span class="paragraph paragraph--sm__font paragraph--neun">Graphiques :</span> NVIDIA GeForce GTX 1050',
        directxText: '<span class="paragraph paragraph--sm__font paragraph--neun">DirectX :</span> Version 12',
        storageText: '<span class="paragraph paragraph--sm__font paragraph--neun">Espace disque :</span> 50 GB d\'espace disque disponible',
        additionalText: '<span class="paragraph paragraph--sm__font paragraph--neun">Notes supplémentaires :</span> SSD recommended',
        recommendedText: 'Recommandée :',
        processor2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Processeur :</span> Intel Core i7-12700',
        memory2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Mémoire vive :</span> 32 GB de mémoire',
        graphics2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Graphiques :</span> NVIDIA GeForce RTX 3070',
        dlcTitle: 'DLC',
        dlcAbout: '',
        dlcArsenal: "Ensemble d'apparences d'Arsenal",
        dlcEquipment: "Ensemble d'équipements spéciaux",
        dlcSFX: "Ensemble d'effets spéciaux d'arme",
        dlchairstyles: 'Coupes gratuites',
        dlcemotes: 'Émoticône gratuite',
        dlcAvatar1: "Pack de personnalisation d'avatar 1",
        dlcAvatar2: "Pack de personnalisation d'avatar 2",
        dlcEmote2: "Ensemble d'émoticônes",
        dlcFreeReclaimer: 'Ensemble de tenues Reclaimers',
        dlcHairstyle: 'Ensemble de coupes de cheveux 1',
        dlcHairstyle2: 'Ensemble de coupes de cheveux 2',
        dlcHairstyle3: 'Ensemble de coupes de cheveux 3',
        dlcHairstyle4: 'Ensemble de coupes de cheveux 4',
        dlcHairstyle5: 'Ensemble de coupes de cheveux 5',
        dlcHairstyle6: 'Ensemble de coupes de cheveux 6',
        dlcHairstyle7: 'Ensemble de coupes de cheveux 7',
        dlcHairstyle8: 'Ensemble de coupes de cheveux 8',
        firstReleaseText: '25 Septembre',
        gamelaunchText: 'Disponible au lancement du jeu',
        roadmapText: 'Le boss supplémentaire de la première mise à jour gratuite, Grausam RT: Ω, a été publié plus tôt que prévu, le 25 septembre au lieu du 3 octobre initialement prévu.',
        dlcAvatar3: "Pack de personnalisation d'avatar 3",
        dlcAvatar4: "Pack de personnalisation d'avatar 4",
        dlcIrisOutfit: "Tenue d'Iris gratuite",
        secondReleaseText: '3 Octobre',
        thirdReleaseText: '17 Octobre',
        dlc__formalsuit: 'Costume formel gratuit',
        dlc__axiomresearcher: "Tenue gratuite de chercheur de l'Axiome",
        dlc__sovereign: 'Ensemble de tenues Axiome Souverain',
        dlc__grand1: 'Ensemble Entrée en scène 1',
        dlc__grand2: 'Ensemble Entrée en scène 2',
        dlc__vehicle: 'Ensemble de véhicules',
        dlc__decal: "Ensemble d'autocollants",
        fourthdReleaseText: '30 Octobre',
        dlc__intoabyss: 'Into the Abyss',
        dlc__avatarcustom5: "Pack de personnalisation d'avatar 5",
        dlc__stampset: 'Ensemble de tampons',
        fifthReleaseText: '14 Novembre',
        dlc__valkyrie: 'Équipement métallique - Valkyrie Will (Lance)',
        dlc__noxus: 'Équipement métallique - Noxus Glitter (Fusil laser)',
        dlc__silverraven: 'Équipement métallique - Silver Raven (Mitraillette)',
        dlc__grimreaper: "Équipement métallique - Grim Reaper (Fusil d'assaut)",
        dlc__levendis: 'Équipement métallique - Levendis (Lame)',
        dlc__shiden: 'Équipement métallique - Shiden (Tachi)',
        sixthReleaseText: '5 Décembre',
    },
    de: {
        preorder: 'Jetzt Erhältlich',
        country: 'Land',
        edition: 'Edition',
        platform: 'Plattform',
        retailers: 'Einzelhändler',
        preorderBtn: 'Jetzt Erhältlich!',
        selectAnOption: 'Option auswählen',
        comingSoon: 'Demnächst verfügbar',
        demoTitle: 'Demo jetzt verfügbar',
        disclaimer: 'Benutzer von PlayStation®5 und Xbox Series X|S, die die Digital Deluxe oder Super Digital Deluxe Edition erwerben, müssen das Erweiterungspaket, das Outfit-Set der Reclaimer und das Outfit-Set des Souveränen Axioms manuell herunterladen, sobald diese verfügbar sind.',
        keyTitle: 'Hauptinhalte',
        play: 'Spiele den ersten Teil der Geschichte durch',
        save: 'Speicherdaten werden in die Vollversion übernommen',
        playSolo: 'Spiele solo oder mit Freunden im Online-Koop-Modus mit Crossplay',
        specTitle: 'SystemanforderungenD4',
        minText: 'Mindestanforderungen:',
        requireText: 'Setzt 64-Bit-Prozessor und -Betriebssystem voraus',
        osText: '<span class="paragraph paragraph--sm__font paragraph--neun">Betriebssystem:</span> Windows 10',
        processorText: '<span class="paragraph paragraph--sm__font paragraph--neun">Prozessor:</span> Intel Core i5-10400',
        memoryText: '<span class="paragraph paragraph--sm__font paragraph--neun">Arbeitsspeicher:</span> 16 GB RAM',
        graphicsText: '<span class="paragraph paragraph--sm__font paragraph--neun">Grafik:</span> NVIDIA GeForce GTX 1050',
        directxText: '<span class="paragraph paragraph--sm__font paragraph--neun">DirectX:</span> Version 12',
        storageText: '<span class="paragraph paragraph--sm__font paragraph--neun">Speicherplatz:</span> 50 GB verfügbarer Speicherplatz',
        additionalText: '<span class="paragraph paragraph--sm__font paragraph--neun">Zusätzliche Anmerkungen:</span> SSD recommended',
        recommendedText: 'Empfohlen:',
        processor2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Prozessor:</span> Intel Core i7-12700',
        memory2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Arbeitsspeicher:</span> 32 GB RAM',
        graphics2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Grafik:</span> NVIDIA GeForce RTX 3070',
        dlcTitle: 'DLC',
        dlcAbout: '',
        dlcArsenal: 'Arsenal-Skin-Set',
        dlcEquipment: 'Spezialausrüstung-Set',
        dlcSFX: 'Waffen-Set mit speziellen Soundeffekten',
        dlchairstyles: 'Gratis Frisuren',
        dlcemotes: 'Gratis Emotes',
        dlcAvatar1: 'Avatar-Anpassungspaket 1',
        dlcAvatar2: 'Avatar-Anpassungspaket 2',
        dlcEmote2: 'Emote-Set',
        dlcFreeReclaimer: 'Outfit-Set der Reclaimer',
        dlcHairstyle: 'Frisuren-Set 1',
        dlcHairstyle2: 'Frisuren-Set 2',
        dlcHairstyle3: 'Frisuren-Set 3',
        dlcHairstyle4: 'Frisuren-Set 4',
        dlcHairstyle5: 'Frisuren-Set 5',
        dlcHairstyle6: 'Frisuren-Set 6',
        dlcHairstyle7: 'Frisuren-Set 7',
        dlcHairstyle8: 'Frisuren-Set 8',
        firstReleaseText: '25 September',
        gamelaunchText: 'Verfügbar bei Spielstart',
        roadmapText: 'Der zusätzliche Boss des ersten kostenlosen Updates, Grausam RT: Ω, wurde vorzeitig am 25. September statt wie ursprünglich geplant am 3. Oktober veröffentlicht.',
        dlcAvatar3: 'Avatar-Anpassungspaket 3',
        dlcAvatar4: 'Avatar-Anpassungspaket 4',
        dlcIrisOutfit: 'Gratis Iris-Outfit',
        secondReleaseText: '3 Oktober',
        thirdReleaseText: '17 Oktober',
        dlc__formalsuit: 'Gratis formelles Outfit',
        dlc__axiomresearcher: 'Gratis Axiomforscher-Outfit',
        dlc__sovereign: 'Outfit-Set des Souveränen Axioms',
        dlc__grand1: '„Auftritt“-Set 1',
        dlc__grand2: '„Auftritt“-Set 2',
        dlc__vehicle: 'Fahrzeug-Set',
        dlc__decal: 'Aufkleber-Set',
        fourthdReleaseText: '30 Oktober',
        dlc__intoabyss: 'In den Abgrund',
        dlc__avatarcustom5: 'Avatar-Anpassungspaket 5',
        dlc__stampset: 'Sticker-Set',
        fifthReleaseText: '14 November',
        dlc__valkyrie: 'Metallische Ausrüstung - Walkürenwille (Lanze)',
        dlc__noxus: 'Metallische Ausrüstung - Noxus Glitter <br/>(Lasergewehr)',
        dlc__silverraven: 'Metallische Ausrüstung - Silver Raven (Maschinengewehr)',
        dlc__grimreaper: 'Metallische Ausrüstung - Grim Reaper (Sturmgewehr)',
        dlc__levendis: 'Metallische Ausrüstung - Levendis (Klinge)',
        dlc__shiden: 'Metallische Ausrüstung - Shiden (Tachi-Schwert)',
        sixthReleaseText: '5 Dezember',
    },
    es: {
        preorder: 'Ya Disponible',
        country: 'País',
        edition: 'Edición',
        platform: 'Plataforma',
        retailers: 'Minoristas',
        preorderBtn: '¡Ya Disponible!',
        selectAnOption: 'Seleccionar una opción',
        comingSoon: 'Próximamente',
        demoTitle: 'Demo ya disponible',
        disclaimer: 'Los usuarios de PlayStation®5 y Xbox Series X|S que compren la edición Digital Deluxe o Super Digital Deluxe deberán descargar manualmente el paquete de expansión, el conjunto de atuendos de Los Reclaimers y el conjunto de atuendos de Sovereign Axiom cuando estén disponibles.',
        keyTitle: 'Características principales',
        play: 'Juega la primera parte de la historia',
        save: 'Los datos guardados se transfieren al juego completo',
        playSolo: 'Juega solo o con amigos en el modo cooperativo online con crossplay',
        specTitle: 'Requisitos del sistema',
        minText: 'Mínimo:',
        requireText: 'Requiere un procesador y un sistema operativo de 64',
        osText: '<span class="paragraph paragraph--sm__font paragraph--neun">SO:</span> Windows 10',
        processorText: '<span class="paragraph paragraph--sm__font paragraph--neun">Procesador:</span> Intel Core i5-10400',
        memoryText: '<span class="paragraph paragraph--sm__font paragraph--neun">Memoria:</span> 16 GB RAM',
        graphicsText: '<span class="paragraph paragraph--sm__font paragraph--neun">Gráficos:</span> NVIDIA GeForce GTX 1050',
        directxText: '<span class="paragraph paragraph--sm__font paragraph--neun">DirectX:</span> Versión 12',
        storageText: '<span class="paragraph paragraph--sm__font paragraph--neun">Almacenamiento:</span> 50 GB de espacio disponible',
        additionalText: '<span class="paragraph paragraph--sm__font paragraph--neun">Notas adicionales:</span> SSD recommended',
        recommendedText: 'Recomendado:',
        processor2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Procesador:</span> Intel Core i7-12700',
        memory2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Memoria:</span> 32 GB RAM',
        graphics2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Gráficos:</span> NVIDIA GeForce RTX 3070',
        dlcTitle: 'DLC',
        dlcAbout: '',
        dlcArsenal: 'Conjunto de diseños del Arsenal',
        dlcEquipment: 'Conjunto de equipo especial',
        dlcSFX: 'Conjunto de armas con efectos de sonido especiales',
        dlchairstyles: 'Peinados gratis',
        dlcemotes: 'Emoticonos gratis',
        dlcAvatar1: 'Paquete de personalización del avatar 1',
        dlcAvatar2: 'Paquete de personalización del avatar 2',
        dlcEmote2: 'Conjunto de emoticonos',
        dlcFreeReclaimer: 'Conjunto de atuendos de Los Reclaimers.',
        dlcHairstyle: 'Conjunto de peinado 1',
        dlcHairstyle2: 'Conjunto de peinado 2',
        dlcHairstyle3: 'Conjunto de peinado 3',
        dlcHairstyle4: 'Conjunto de peinado 4',
        dlcHairstyle5: 'Conjunto de peinado 5',
        dlcHairstyle6: 'Conjunto de peinado 6',
        dlcHairstyle7: 'Conjunto de peinado 7',
        dlcHairstyle8: 'Conjunto de peinado 8',
        firstReleaseText: '25 Septiembre',
        gamelaunchText: 'Disponible en el lanzamiento del juego',
        roadmapText: 'El jefe adicional de la primera actualización gratuita, Grausam RT: Ω, se ha lanzado antes de lo previsto, el 25 de septiembre, en lugar de la fecha inicialmente prevista, el 3 de octubre.',
        dlcAvatar3: 'Paquete de personalización del avatar 3',
        dlcAvatar4: 'Paquete de personalización del avatar 4',
        dlcIrisOutfit: 'Atuendo gratis de Iris',
        secondReleaseText: '3 Octubre',
        thirdReleaseText: '17 Octubre',
        dlc__formalsuit: 'Atuendo gratis de traje formal',
        dlc__axiomresearcher: 'Atuendo gratis de investigador de Axiom',
        dlc__sovereign: 'Conjunto de atuendos de Sovereign Axiom',
        dlc__grand1: 'Conjunto de aparición estelar 1',
        dlc__grand2: 'Conjunto de aparición estelar 2',
        dlc__vehicle: 'Conjunto de vehículos',
        dlc__decal: 'Conjunto de pegatinas',
        fourthdReleaseText: '30 Octubre',
        dlc__intoabyss: 'Hacia el abismo',
        dlc__avatarcustom5: 'Paquete de personalización del avatar 5',
        dlc__stampset: 'Conjunto de sellos',
        fifthReleaseText: '14 Noviembre',
        dlc__valkyrie: 'Equipo metálico - Valkyrie Will (Lanza)',
        dlc__noxus: 'Equipo metálico - Noxus Glitter (Fusil láser)',
        dlc__silverraven: 'Equipo metálico - Silver Raven (Ametralladora)',
        dlc__grimreaper: 'Equipo metálico - Grim Reaper (Fusil de asalto)',
        dlc__levendis: 'Equipo metálico - Levendis (Espada)',
        dlc__shiden: 'Equipo metálico - Shiden (Tachi)',
        sixthReleaseText: '5 Diciembre',
    },
    it: {
        preorder: 'Ora disponibile',
        country: 'Paese',
        edition: 'Edizione',
        platform: 'Piattaforma',
        retailers: 'Rivenditori',
        preorderBtn: 'Ora disponibile!',
        selectAnOption: "Seleziona un'opzione",
        comingSoon: 'In arrivo',
        demoTitle: 'Demo ora disponibile',
        disclaimer: 'Gli utenti PlayStation®5 e Xbox Series X|S che acquistano la Digital Deluxe Edition o la Super Digital Deluxe Edition devono scaricare manualmente il pacchetto di espansione, il set di abbigliamento Reclaimers e il set di abbigliamento Sovereign Axiom quando saranno disponibili.',
        keyTitle: 'Caratteristiche principali',
        play: 'Gioca la prima parte della storia',
        save: 'I dati salvati vengono trasferiti al gioco completo',
        playSolo: 'Gioca da solo o con gli amici in modalità cooperativa online  con il crossplay ',
        specTitle: 'Requisiti di sistema',
        minText: 'Minimi:',
        requireText: 'Richiede un processore e un sistema operativo a 64',
        osText: '<span class="paragraph paragraph--sm__font paragraph--neun">Sistema operativo:</span> Windows 10',
        processorText: '<span class="paragraph paragraph--sm__font paragraph--neun">Processore:</span> Intel Core i5-10400',
        memoryText: '<span class="paragraph paragraph--sm__font paragraph--neun">Memoria:</span> 16 GB di RAM',
        graphicsText: '<span class="paragraph paragraph--sm__font paragraph--neun">Scheda video:</span> NVIDIA GeForce GTX 1050',
        directxText: '<span class="paragraph paragraph--sm__font paragraph--neun">DirectX:</span> Versione 12',
        storageText: '<span class="paragraph paragraph--sm__font paragraph--neun">Memoria:</span> 50 GB di spazio disponibile',
        additionalText: '<span class="paragraph paragraph--sm__font paragraph--neun">Note aggiuntive:</span> SSD recommended',
        recommendedText: 'Consigliati:',
        processor2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Processore:</span> Intel Core i7-12700',
        memory2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Memoria:</span> 32 GB di RAM',
        graphics2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Scheda video:</span> NVIDIA GeForce RTX 3070',
        dlcTitle: 'DLC',
        dlcAbout: '',
        dlcArsenal: 'Set di aspetti per Arsenal',
        dlcEquipment: 'Set equipaggiamenti speciali',
        dlcSFX: 'Set armi con effetti speciali',
        dlchairstyles: 'Acconciature gratis',
        dlcemotes: 'Emote gratis',
        dlcAvatar1: "Pacchetto per personalizzazione dell'avatar 1",
        dlcAvatar2: "Pacchetto per personalizzazione dell'avatar 2",
        dlcEmote2: 'Set di emote',
        dlcFreeReclaimer: 'Set di abbigliamento Reclaimer',
        dlcHairstyle: 'Set di acconciature 1',
        dlcHairstyle2: 'Set di acconciature 2',
        dlcHairstyle3: 'Set di acconciature 3',
        dlcHairstyle4: 'Set di acconciature 4',
        dlcHairstyle5: 'Set di acconciature 5',
        dlcHairstyle6: 'Set di acconciature 6',
        dlcHairstyle7: 'Set di acconciature 7',
        dlcHairstyle8: 'Set di acconciature 8',
        firstReleaseText: '25 Settembre',
        gamelaunchText: 'Disponibile al lancio del gioco',
        roadmapText: 'Il boss aggiuntivo del primo aggiornamento gratuito, Grausam RT: Ω, è stato rilasciato in anticipo il 25 settembre invece che il 3 ottobre come inizialmente previsto.',
        dlcAvatar3: "Pacchetto per personalizzazione dell'avatar 3",
        dlcAvatar4: "Pacchetto per personalizzazione dell'avatar 4",
        dlcIrisOutfit: 'Completo di Iris gratis',
        secondReleaseText: '3 Ottobre',
        thirdReleaseText: '17 Ottobre',
        dlc__formalsuit: 'Completo formale gratis',
        dlc__axiomresearcher: 'Completo da ricercatore Axiom gratis',
        dlc__sovereign: 'Set di abbigliamento Sovereign Axiom',
        dlc__grand1: 'Set di entrate teatrali 1',
        dlc__grand2: 'Set di entrate teatrali 2',
        dlc__vehicle: 'Set di veicoli',
        dlc__decal: 'Set di decalcomanie',
        fourthdReleaseText: '30 Ottobre',
        dlc__intoabyss: "Nell'abisso",
        dlc__avatarcustom5: "Pacchetto per personalizzazione dell'avatar 5",
        dlc__stampset: 'Set di timbri',
        fifthReleaseText: '14 Novembre',
        dlc__valkyrie: 'Equipaggiamento metallico - Valkyrie Will (Lancia)',
        dlc__noxus: 'Equipaggiamento metallico - Noxus Glitter (Fucile laser)',
        dlc__silverraven: 'Equipaggiamento metallico - Silver Raven (Mitragliatrice)',
        dlc__grimreaper: "Equipaggiamento metallico - Grim Reaper <br/>(Fucile d'assalto)",
        dlc__levendis: 'Equipaggiamento metallico - Levendis (Spada)',
        dlc__shiden: 'Equipaggiamento metallico - Shiden (Tachi)',
        sixthReleaseText: '5 Dicembre',
    },
    pt: {
        preorder: 'Já disponível',
        country: 'País',
        edition: 'Edição',
        platform: 'Plataforma',
        retailers: 'Revendedores',
        preorderBtn: 'Já disponível!',
        selectAnOption: 'Selecionar uma opção',
        comingSoon: 'Em breve disponível',
        demoTitle: 'Demo já disponível',
        disclaimer: 'Os utilizadores da PlayStation®5 e Xbox Series X|S que adquirirem a Edição Digital Deluxe ou Super Digital Deluxe deverão descarregar manualmente o Pacote de Expansão, o Conjunto de visuais para Reclaimers e o Conjunto de visuais do Axioma Soberano quando estiverem disponíveis.',
        keyTitle: 'Características principais',
        play: 'Jogue a parte inicial da história',
        save: 'Os dados salvos são transferidos para o jogo completo',
        playSolo: 'Jogue sozinho ou com amigos em modo cooperativo online com crossplay',
        specTitle: 'Requisitos do Sistema',
        minText: 'Mínimos:',
        requireText: 'Requer um sistema operativo e processador de 64 bits',
        osText: '<span class="paragraph paragraph--sm__font paragraph--neun">Sistema Operativo:</span> Windows 10',
        processorText: '<span class="paragraph paragraph--sm__font paragraph--neun">Processador:</span> Intel Core i5-10400',
        memoryText: '<span class="paragraph paragraph--sm__font paragraph--neun">Memória:</span> 16 GB de RAM',
        graphicsText: '<span class="paragraph paragraph--sm__font paragraph--neun">Placa gráfica:</span> NVIDIA GeForce GTX 1050',
        directxText: '<span class="paragraph paragraph--sm__font paragraph--neun">DirectX:</span> Versão 12',
        storageText: '<span class="paragraph paragraph--sm__font paragraph--neun">Espaço no disco:</span> Requer 50 GB de espaço livre',
        additionalText: '<span class="paragraph paragraph--sm__font paragraph--neun">Notas adicionais:</span> SSD recommended',
        recommendedText: 'Recomendados:',
        processor2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Processador:</span> Intel Core i7-12700',
        memory2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Memória:</span> 32 GB de RAM',
        graphics2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Placa gráfica:</span> NVIDIA GeForce RTX 3070',
        dlcTitle: 'DLC',
        dlcAbout: '',
        dlcArsenal: 'Conjunto de visuais para Arsenal',
        dlcEquipment: 'Conjunto de equipamento especial',
        dlcSFX: 'Conjunto de efeitos especiais para armas',
        dlchairstyles: 'Penteados grátis',
        dlcemotes: 'Emoticons grátis',
        dlcAvatar1: 'Pacote de personalização de avatar 1',
        dlcAvatar2: 'Pacote de personalização de avatar 2',
        dlcEmote2: 'Conjunto de emoticons',
        dlcFreeReclaimer: 'Conjunto de visuais para Reclaimers',
        dlcHairstyle: 'Conjunto de penteados 1',
        dlcHairstyle2: 'Conjunto de penteados 2',
        dlcHairstyle3: 'Conjunto de penteados 3',
        dlcHairstyle4: 'Conjunto de penteados 4',
        dlcHairstyle5: 'Conjunto de penteados 5',
        dlcHairstyle6: 'Conjunto de penteados 6',
        dlcHairstyle7: 'Conjunto de penteados 7',
        dlcHairstyle8: 'Conjunto de penteados 8',
        firstReleaseText: '25 Setembro',
        gamelaunchText: 'Disponível no lançamento do jogo',
        roadmapText: 'O chefe adicional da primeira atualização gratuita, Grausam RT: Ω, foi lançado antes do previsto, em 25 de setembro, em vez da data originalmente planejada de 3 de outubro.',
        dlcAvatar3: 'Pacote de personalização de avatar 3',
        dlcAvatar4: 'Pacote de personalização de avatar 4',
        dlcIrisOutfit: 'Fato grátis de Iris',
        secondReleaseText: '3 Outubro',
        thirdReleaseText: '17 Outubro',
        dlc__formalsuit: 'Fato formal grátis',
        dlc__axiomresearcher: 'Fato grátis de investigador do Axioma',
        dlc__sovereign: 'Conjunto de visuais do Axioma Soberano',
        dlc__grand1: 'Conjunto Entrada teatral 1',
        dlc__grand2: 'Conjunto Entrada teatral 2',
        dlc__vehicle: 'Conjunto de veículos',
        dlc__decal: 'Conjunto de decalques',
        fourthdReleaseText: '30 Outubro',
        dlc__intoabyss: 'Into the Abyss',
        dlc__avatarcustom5: 'Pacote de personalização de avatar 5',
        dlc__stampset: 'Conjunto de selos',
        fifthReleaseText: '14 Novembro',
        dlc__valkyrie: 'Equipamento Metálico - Vontade da Valquíria (Lança)',
        dlc__noxus: 'Equipamento Metálico - Noxious Glitter <br/>(Espingarda-laser)',
        dlc__silverraven: 'Equipamento Metálico - Silver Raven <br/>(Metralhadora)',
        dlc__grimreaper: 'Equipamento Metálico - Grim Reaper <br/>(Espingarda de assalto)',
        dlc__levendis: 'Equipamento Metálico - Levendis (Lâmina)',
        dlc__shiden: 'Equipamento Metálico - Shiden (Taichi)',
        sixthReleaseText: '5 Dezembro',
    },
    nl: {
        preorder: 'Nu verkrijgbaar',
        country: 'Land',
        edition: 'Editie',
        platform: 'Platform',
        retailers: 'Verkooppunten',
        preorderBtn: 'Nu verkrijgbaar!',
        selectAnOption: 'Selecteer een optie',
        comingSoon: 'Binnenkort beschikbaar',
        demoTitle: 'Demo nu beschikbaar',
        disclaimer: 'PlayStation®5- en Xbox Series X|S-gebruikers die de Digital Deluxe- of Super Digital Deluxe-editie aanschaffen, moeten het uitbreidingspakket, de Reclaimers-outfitset en de Soevereine Axioma-outfitset handmatig downloaden zodra deze beschikbaar zijn.',
        keyTitle: 'Hoofdkenmerken',
        play: 'Speel het eerste deel van het verhaal',
        save: 'Je gegevens worden opgeslagen voor de volledige game',
        playSolo: 'Speel solo of met vrienden in online coöp met crossplay',
        specTitle: 'Systeemeisen',
        minText: 'Minimum:',
        requireText: 'Vereist een 64-bitsprocessor en -besturingssysteem',
        osText: '<span class="paragraph paragraph--sm__font paragraph--neun">Besturingssysteem:</span> Windows 10',
        processorText: '<span class="paragraph paragraph--sm__font paragraph--neun">Processor:</span> Intel Core i5-10400',
        memoryText: '<span class="paragraph paragraph--sm__font paragraph--neun">Geheugen:</span> 16 GB RAM',
        graphicsText: '<span class="paragraph paragraph--sm__font paragraph--neun">Grafische kaart:</span> NVIDIA GeForce GTX 1050',
        directxText: '<span class="paragraph paragraph--sm__font paragraph--neun">DirectX:</span> Versie 12',
        storageText: '<span class="paragraph paragraph--sm__font paragraph--neun">Opslagruimte:</span> 50 GB beschikbare ruimte',
        additionalText: '<span class="paragraph paragraph--sm__font paragraph--neun">Aanvullende opmerkingen:</span> SSD recommended',
        recommendedText: 'Aanbevolen:',
        processor2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Processor:</span> Intel Core i7-12700',
        memory2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Geheugen:</span> 32 GB RAM',
        graphics2Text: '<span class="paragraph paragraph--sm__font paragraph--neun">Grafische kaart:</span> NVIDIA GeForce RTX 3070',
        dlcTitle: 'DLC',
        dlcAbout: '',
        dlcArsenal: 'Arsenal-skinset',
        dlcEquipment: 'Speciale uitrustingsset',
        dlcSFX: 'Speciale SFX-wapenset',
        dlchairstyles: 'Gratis haarstijlen',
        dlcemotes: 'Gratis emotes',
        dlcAvatar1: 'Avatar-aanpassingspakket 1',
        dlcAvatar2: 'Avatar-aanpassingspakket 2',
        dlcEmote2: 'Emote-set',
        dlcFreeReclaimer: 'Reclaimers-outfitset',
        dlcHairstyle: 'Haarstijlset 1',
        dlcHairstyle2: 'Haarstijlset 2',
        dlcHairstyle3: 'Haarstijlset 3',
        dlcHairstyle4: 'Haarstijlset 4',
        dlcHairstyle5: 'Haarstijlset 5',
        dlcHairstyle6: 'Haarstijlset 6',
        dlcHairstyle7: 'Haarstijlset 7',
        dlcHairstyle8: 'Haarstijlset 8',
        firstReleaseText: '25 September',
        gamelaunchText: 'Beschikbaar bij de lancering van het spel',
        roadmapText: 'De extra baas van de eerste gratis update, Grausam RT: Ω, is eerder dan gepland uitgebracht, namelijk op 25 september in plaats van op 3 oktober zoals oorspronkelijk gepland.',
        dlcAvatar3: 'Avatar-aanpassingspakket 3',
        dlcAvatar4: 'Avatar-aanpassingspakket 4',
        dlcIrisOutfit: 'Gratis Iris-outfit',
        secondReleaseText: '3 Oktober',
        thirdReleaseText: '17 Oktober',
        dlc__formalsuit: 'Gratis formeel pak',
        dlc__axiomresearcher: 'Gratis Axiomaonderzoeker-outfit',
        dlc__sovereign: 'Soevereine Axioma-outfitset ',
        dlc__grand1: 'Grootse intrede set 1',
        dlc__grand2: 'Grootse intrede set 2',
        dlc__vehicle: 'Voertuigset',
        dlc__decal: 'Stickerset',
        fourthdReleaseText: '30 Oktober',
        dlc__intoabyss: 'In de leegte',
        dlc__avatarcustom5: 'Avatar-aanpassingspakket 5',
        dlc__stampset: 'Stempelset',
        fifthReleaseText: '14 November',
        dlc__valkyrie: 'Metallic uitrusting - Valkyrie Will (lans)',
        dlc__noxus: 'Metallic uitrusting - Noxusglitter (lasergeweer)',
        dlc__silverraven: 'Metallic uitrusting - Zilveren raaf (machinegeweer)',
        dlc__grimreaper: 'Metallic uitrusting - Grim Reaper (aanvalsgeweer)',
        dlc__levendis: 'Metallic uitrusting - Levendis (zwaard)',
        dlc__shiden: 'Metallic uitrusting - Shiden (taichi)',
        sixthReleaseText: '5 December',
    },
};
class ProductsContent {
    constructor() {
        this.preorder = document.querySelector('.preOrderTitle');
        this.country = document.querySelector('.country h3');
        this.edition = document.querySelector('.edition h3');
        this.platform = document.querySelector('.platform h3');
        this.retailers = document.querySelector('.retailers h3');
        this.preorderBtn = document.querySelectorAll('.btn h2');
        this.comingsoon = document.querySelector('.comingSoon');
        this.selectAnOption = document.querySelectorAll('.select__option label');
        this.specTitle = document.querySelector('.specTitle');
        this.minText = document.querySelector('.minText');
        this.requireText = document.querySelectorAll('.requireText');
        this.osText = document.querySelectorAll('.osText');
        this.processorText = document.querySelector('.processorText');
        this.memoryText = document.querySelector('.memoryText');
        this.graphicsText = document.querySelector('.graphicsText');
        this.directxText = document.querySelectorAll('.directxText');
        this.storageText = document.querySelectorAll('.storageText');
        this.additionalText = document.querySelectorAll('.additionalText');
        this.recommendedText = document.querySelector('.recommendedText');
        this.processor2Text = document.querySelector('.processor2Text');
        this.memory2Text = document.querySelector('.memory2Text');
        this.graphics2Text = document.querySelector('.graphics2Text');
        this.demoTitle = document.querySelector('.demoTitle');
        this.disclaimer = document.querySelector('.disclaimer');
        this.keyTitle = document.querySelector('.keyFeature');
        this.play = document.querySelector('.playThrough');
        this.save = document.querySelector('.saveData');
        this.playSolo = document.querySelector('.playSolo');
        this.dlcTitle = document.querySelector('.dlc__title');
        this.dlcAbout = document.querySelector('.dlc__about');
        this.dlcArsenal = document.querySelector('.dlc__arsenal');
        this.dlcEquipment = document.querySelector('.dlc__equipment');
        this.dlcSFX = document.querySelector('.dlc__sfx');
        this.dlchairstyles = document.querySelector('.dlc__hairstyles');
        this.dlcemotes = document.querySelector('.dlc__emotes');
        this.dlcAvatar1 = document.querySelector('.dlc__avatar1');
        this.dlcAvatar2 = document.querySelector('.dlc__avatar2');
        this.dlcEmote2 = document.querySelector('.dlc__emote2');
        this.dlcFreeReclaimer = document.querySelector('.dlc__Reclaimer__Outfit');
        this.dlcHairstyle = document.querySelector('.dlc__hairstyle');
        this.dlcHairstyle2 = document.querySelector('.dlc__hairstyle2');
        this.dlcHairstyle3 = document.querySelector('.dlc__hairstyle3');
        this.dlcHairstyle4 = document.querySelector('.dlc__hairstyle4');
        this.dlcHairstyle5 = document.querySelector('.dlc__hairstyle5');
        this.dlcHairstyle6 = document.querySelector('.dlc__hairstyle6');
        this.dlcHairstyle7 = document.querySelector('.dlc__hairstyle7');
        this.dlcHairstyle8 = document.querySelector('.dlc__hairstyle8');
        this.firstReleaseText = document.querySelector('.firstReleaseText');
        this.gamelaunchText = document.querySelector('.gamelaunchText');
        this.roadmapText = document.querySelector('.roadmap__text');
        this.dlcAvatar3 = document.querySelector('.dlc__avatar3');
        this.dlcAvatar4 = document.querySelector('.dlc__avatar4');
        this.dlcIrisOutfit = document.querySelector('.dlc__iris');
        this.secondReleaseText = document.querySelector('.secondReleaseText');
        this.thirdReleaseText = document.querySelector('.thirdReleaseText');
        this.dlc__formalsuit = document.querySelector('.dlc__formalsuit');
        this.dlc__axiomresearcher = document.querySelector('.dlc__axiomresearcher');
        this.dlc__sovereign = document.querySelector('.dlc__sovereign');
        this.dlc__grand1 = document.querySelector('.dlc__grand1');
        this.dlc__grand2 = document.querySelector('.dlc__grand2');
        this.dlc__vehicle = document.querySelector('.dlc__vehicle');
        this.dlc__decal = document.querySelector('.dlc__decal');
        this.fourthdReleaseText = document.querySelector('.fourthdReleaseText');
        this.dlc__intoabyss = document.querySelector('.dlc__intoabyss');
        this.dlc__avatarcustom5 = document.querySelector('.dlc__avatarcustom5');
        this.dlc__stampset = document.querySelector('.dlc__stampset');
        this.fifthReleaseText = document.querySelector('.fifthReleaseText');
        this.dlc__valkyrie = document.querySelector('.dlc__valkyrie');
        this.dlc__noxus = document.querySelector('.dlc__noxus');
        this.dlc__silverraven = document.querySelector('.dlc__silverraven');
        this.dlc__grimreaper = document.querySelector('.dlc__grimreaper');
        this.dlc__levendis = document.querySelector('.dlc__levendis');
        this.dlc__shiden = document.querySelector('.dlc__shiden');
        this.sixthReleaseText = document.querySelector('.sixthReleaseText');
        this.init();
    }
    init() {
        this.updateText();
    }
    updateText() {
        const language = (0, languageUtils_1.getLanguage)();
        const content = productsText[language] || productsText['en'];
        // REMOVE THIS PART ONCE PURCHASE GOES BACK
        if (this.comingsoon)
            this.comingsoon.textContent = content.comingSoon.toUpperCase();
        if (this.preorder)
            this.preorder.textContent = content.preorder.toUpperCase();
        if (this.country)
            this.country.textContent =
                content.country.charAt(0).toUpperCase() +
                    content.country.slice(1).toLowerCase();
        if (this.edition)
            this.edition.textContent =
                content.edition.charAt(0).toUpperCase() +
                    content.edition.slice(1).toLowerCase();
        if (this.platform)
            this.platform.textContent =
                content.platform.charAt(0).toUpperCase() +
                    content.platform.slice(1).toLowerCase();
        if (this.retailers)
            this.retailers.textContent =
                content.retailers.charAt(0).toUpperCase() +
                    content.retailers.slice(1).toLowerCase();
        if (this.preorderBtn)
            this.preorderBtn.forEach(btn => {
                btn.textContent = content.preorderBtn.toUpperCase();
            });
        if (this.selectAnOption)
            this.selectAnOption.forEach(item => {
                item.textContent = content.selectAnOption;
            });
        if (this.specTitle)
            this.specTitle.textContent = content.specTitle.toUpperCase();
        if (this.minText)
            this.minText.textContent = content.minText;
        if (this.requireText)
            this.requireText.forEach(item => {
                item.textContent = content.requireText;
            });
        if (this.osText)
            this.osText.forEach(item => {
                item.innerHTML = content.osText;
            });
        if (this.processorText)
            this.processorText.innerHTML = content.processorText;
        if (this.memoryText)
            this.memoryText.innerHTML = content.memoryText;
        if (this.graphicsText)
            this.graphicsText.innerHTML = content.graphicsText;
        if (this.directxText)
            this.directxText.forEach(item => {
                item.innerHTML = content.directxText;
            });
        if (this.storageText)
            this.storageText.forEach(item => {
                item.innerHTML = content.storageText;
            });
        if (this.additionalText)
            this.additionalText.forEach(item => {
                item.innerHTML = content.additionalText;
            });
        if (this.recommendedText)
            this.recommendedText.textContent = content.recommendedText;
        if (this.processor2Text)
            this.processor2Text.innerHTML = content.processor2Text;
        if (this.memory2Text)
            this.memory2Text.innerHTML = content.memory2Text;
        if (this.graphics2Text)
            this.graphics2Text.innerHTML = content.graphics2Text;
        if (this.demoTitle)
            this.demoTitle.textContent = content.demoTitle;
        if (this.disclaimer)
            this.disclaimer.textContent = content.disclaimer;
        if (this.keyTitle)
            this.keyTitle.textContent = content.keyTitle;
        if (this.play)
            this.play.textContent = content.play;
        if (this.save)
            this.save.textContent = content.save;
        if (this.playSolo)
            this.playSolo.textContent = content.playSolo;
        if (this.dlcTitle)
            this.dlcTitle.textContent = content.dlcTitle;
        if (this.dlcAbout)
            this.dlcAbout.textContent = content.dlcAbout;
        if (this.dlcArsenal)
            this.dlcArsenal.textContent = content.dlcArsenal;
        if (this.dlcEquipment)
            this.dlcEquipment.textContent = content.dlcEquipment;
        if (this.dlcSFX)
            this.dlcSFX.textContent = content.dlcSFX;
        if (this.dlchairstyles)
            this.dlchairstyles.textContent = content.dlchairstyles;
        if (this.dlcemotes)
            this.dlcemotes.textContent = content.dlcemotes;
        if (this.dlcAvatar1)
            this.dlcAvatar1.textContent = content.dlcAvatar1;
        if (this.dlcAvatar2)
            this.dlcAvatar2.textContent = content.dlcAvatar2;
        if (this.dlcEmote2)
            this.dlcEmote2.textContent = content.dlcEmote2;
        if (this.dlcFreeReclaimer)
            this.dlcFreeReclaimer.textContent = content.dlcFreeReclaimer;
        if (this.dlcHairstyle)
            this.dlcHairstyle.textContent = content.dlcHairstyle;
        if (this.dlcHairstyle2)
            this.dlcHairstyle2.textContent = content.dlcHairstyle2;
        if (this.dlcHairstyle3)
            this.dlcHairstyle3.textContent = content.dlcHairstyle3;
        if (this.dlcHairstyle4)
            this.dlcHairstyle4.textContent = content.dlcHairstyle4;
        if (this.dlcHairstyle5)
            this.dlcHairstyle5.textContent = content.dlcHairstyle5;
        if (this.dlcHairstyle6)
            this.dlcHairstyle6.textContent = content.dlcHairstyle6;
        if (this.dlcHairstyle7)
            this.dlcHairstyle7.textContent = content.dlcHairstyle7;
        if (this.dlcHairstyle8)
            this.dlcHairstyle8.textContent = content.dlcHairstyle8;
        if (this.firstReleaseText)
            this.firstReleaseText.textContent = content.firstReleaseText;
        if (this.gamelaunchText)
            this.gamelaunchText.textContent = content.gamelaunchText;
        if (this.roadmapText)
            this.roadmapText.textContent = content.roadmapText;
        if (this.dlcAvatar3)
            this.dlcAvatar3.textContent = content.dlcAvatar3;
        if (this.dlcAvatar4)
            this.dlcAvatar4.textContent = content.dlcAvatar4;
        if (this.dlcIrisOutfit)
            this.dlcIrisOutfit.textContent = content.dlcIrisOutfit;
        if (this.secondReleaseText)
            this.secondReleaseText.textContent = content.secondReleaseText;
        if (this.thirdReleaseText)
            this.thirdReleaseText.textContent = content.thirdReleaseText;
        if (this.dlc__formalsuit)
            this.dlc__formalsuit.textContent = content.dlc__formalsuit;
        if (this.dlc__axiomresearcher)
            this.dlc__axiomresearcher.textContent = content.dlc__axiomresearcher;
        if (this.dlc__sovereign)
            this.dlc__sovereign.textContent = content.dlc__sovereign;
        if (this.dlc__grand1)
            this.dlc__grand1.textContent = content.dlc__grand1;
        if (this.dlc__grand2)
            this.dlc__grand2.textContent = content.dlc__grand2;
        if (this.dlc__vehicle)
            this.dlc__vehicle.textContent = content.dlc__vehicle;
        if (this.dlc__decal)
            this.dlc__decal.textContent = content.dlc__decal;
        if (this.fourthdReleaseText)
            this.fourthdReleaseText.textContent = content.fourthdReleaseText;
        if (this.dlc__intoabyss)
            this.dlc__intoabyss.textContent = content.dlc__intoabyss;
        if (this.dlc__avatarcustom5)
            this.dlc__avatarcustom5.textContent = content.dlc__avatarcustom5;
        if (this.dlc__stampset)
            this.dlc__stampset.textContent = content.dlc__stampset;
        if (this.fifthReleaseText)
            this.fifthReleaseText.textContent = content.fifthReleaseText;
        if (this.dlc__valkyrie)
            this.dlc__valkyrie.innerHTML = content.dlc__valkyrie;
        if (this.dlc__noxus)
            this.dlc__noxus.innerHTML = content.dlc__noxus;
        if (this.dlc__silverraven)
            this.dlc__silverraven.innerHTML = content.dlc__silverraven;
        if (this.dlc__grimreaper)
            this.dlc__grimreaper.innerHTML = content.dlc__grimreaper;
        if (this.dlc__levendis)
            this.dlc__levendis.innerHTML = content.dlc__levendis;
        if (this.dlc__shiden)
            this.dlc__shiden.innerHTML = content.dlc__shiden;
        if (this.sixthReleaseText)
            this.sixthReleaseText.textContent = content.sixthReleaseText;
    }
    static getInstance() {
        if (!ProductsContent.instance) {
            ProductsContent.instance = new ProductsContent();
        }
        return ProductsContent.instance;
    }
    updatePurchaseBtnText() {
        const btnList = document.querySelectorAll('.btn h2');
        const language = (0, languageUtils_1.getLanguage)();
        const content = productsText[language] || productsText['en'];
        if (btnList)
            btnList.forEach(btn => {
                btn.textContent = content.preorderBtn.toUpperCase();
            });
    }
}
exports.ProductsContent = ProductsContent;
